/* CPEEDY Price Fix v3 - cache bust */
(function(){
  function fix(){
    /* Fix all text nodes containing 59.99 */
    var walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null,false);
    var node;
    while(node=walker.nextNode()){
      if(node.nodeValue&&node.nodeValue.indexOf('59.99')>-1){
        node.nodeValue=node.nodeValue.replace(/59\.99/g,'45.99');
      }
    }
    /* Also fix attributes and innerHTML for buttons */
    document.querySelectorAll('button,input[type=submit]').forEach(function(el){
      if(el.value&&el.value.indexOf('59.99')>-1)el.value=el.value.replace(/59\.99/g,'45.99');
      if(el.textContent&&el.textContent.indexOf('59.99')>-1)el.textContent=el.textContent.replace(/59\.99/g,'45.99');
    });
  }
  /* Run at every possible moment */
  fix();
  document.addEventListener('DOMContentLoaded',fix);
  window.addEventListener('load',fix);
  setTimeout(fix,100);
  setTimeout(fix,500);
  setTimeout(fix,1500);
  /* MutationObserver to catch dynamic renders */
  var obs=new MutationObserver(function(){fix();});
  document.addEventListener('DOMContentLoaded',function(){
    obs.observe(document.body,{childList:true,subtree:true,characterData:true});
  });
})();